/**
 * 首页相关的打点
 * - 首页展示
 * - 首页点击
 */

 export default {
    /**
     * @param {*} show
     *  homepage|首页展示
        seach|搜索框展示；
        fastentry|快速入口区域展示
        banner|banner展示;
        recommend|推荐视频展示;
        courses|基础课区域展示;
        article|图书馆区域展示;
        qa|问答区域展示;
       @param {*} number 仅show上报banner时上报
       上报当前banner的播放顺序，数字1、2、3
     */
    homePageShow({ show, number }) {
      this.collect('homepage_show', { show, number });
    },

    /**
     * @param {*} click
     *  seach|首页搜索入口点击；
        seach_enter|在首页搜索框输入关键词后，使用回车确认搜索
        seach_click|在首页搜索框输入关键词后，点击搜索按键确认搜索
        banner|banner点击;
        fastentry|快速入口区域点击；
        recommend|推荐视频点击;
        courses|基础课区域点击;
        article|图书馆区域点击;
        qa|问答区域点击;
     * @param {*} type 教程ID （click上报recommend、courses、article、qa时上报）
        教程的ID
     * @param {*} keyword 文案关键字（仅click上报fastentry时上报）
        快速入口配置的文案
     * @param {*} number banner顺序（仅click上报banner时上报）
        上报当前banner的播放顺序，数字1、2、3
     */
    homePageClick({ click, type, keyword, number }) {
      this.collect('homepage_click', { click, type, keyword, number });
    }
 }
